export const settingsPrimaryButtonClassName =
  "inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-cpaGold bg-cpaGold px-4 text-sm font-semibold text-white transition hover:bg-amber-500 disabled:cursor-not-allowed disabled:opacity-50";

export const settingsSecondaryButtonClassName =
  "inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-4 text-sm font-semibold text-gray-700 transition hover:border-gray-400 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50";

export const settingsResetButtonClassName =
  "inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-gray-500 bg-white px-4 text-sm font-semibold text-gray-600 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50";

// Claude Design compact table-row actions (Chamber Setup lists): 12px/600,
// 7px 14px padding, 6px radius. Edit and Delete share one height.
const settingsRowButtonBaseClassName =
  "inline-flex items-center justify-center rounded-[6px] px-[14px] py-[7px] text-[12px] font-semibold leading-4 transition disabled:cursor-not-allowed disabled:opacity-50";

export const settingsRowEditButtonClassName = `${settingsRowButtonBaseClassName} border-0 bg-[#E1A731] text-white hover:bg-[#C8912A]`;

export const settingsRowDeleteButtonClassName = `${settingsRowButtonBaseClassName} border-0 bg-[#F21B1B] text-white hover:bg-[#D01414]`;

export const settingsRowSaveButtonClassName = `${settingsRowButtonBaseClassName} border-0 bg-[#0A0A0A] text-white hover:bg-black`;

export const settingsRowCancelButtonClassName = `${settingsRowButtonBaseClassName} border border-[#9E9E9E] bg-white text-[#0A0A0A] hover:bg-[#F7F7F8]`;

export const settingsDangerButtonClassName =
  "inline-flex h-9 items-center justify-center gap-1 rounded-md border border-red-500 bg-red-500 px-3 text-sm font-semibold text-white transition hover:bg-red-600 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-300";

// The input class literal moved verbatim to common/dashboard/formStyles.ts
// (dashboardInputClassName) so the promoted CalendarDateInput's default has no
// pages/** dependency; re-exported here under the original name.
export { dashboardInputClassName as settingsInputClassName } from "../../../../common/dashboard/formStyles";

export const settingsReadOnlyInputClassName =
  "h-11 rounded-lg border border-[#DCE4F0] bg-white px-3 text-sm text-gray-800 shadow-sm outline-none transition read-only:bg-gray-100 read-only:text-gray-500 focus:border-cpaGold focus:ring-2 focus:ring-amber-100 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-500";

export const settingsTextareaClassName =
  "min-h-[124px] w-full resize-y rounded-lg border border-[#DCE4F0] bg-white px-3 py-3 text-sm text-gray-900 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-cpaGold focus:ring-2 focus:ring-amber-100";

export const settingsInnerPanelClassName =
  "rounded-lg bg-white p-5";

export const settingsTableHeaderClassName =
  "bg-[#F7F7F8] px-4 py-[14px] text-[13px] font-bold text-[#0A0A0A]";

// Claude Design section card: light #ECECEC border, 12px radius, 28px padding.
export const settingsSectionCardClassName =
  "rounded-[12px] border border-[#ECECEC] bg-white p-7 shadow-[0_1px_2px_rgba(0,0,0,0.04)]";

export const settingsSectionTitleClassName =
  "text-base font-semibold leading-tight text-[#0A0A0A]";

export const settingsSectionDescriptionClassName =
  "mt-1 text-sm leading-[1.5] text-[#0A0A0A]";
